import React, { Component } from 'react'
import { Spin, Button, Form, Layout, PageHeader, Input, message } from 'antd'
import Editor from 'wangeditor'
import PrevImg from '_src/components/PrevImg/PrevImg'
import { UploadIMGToOss } from '_src/utils/base'
import { postSystemMessage, systemMessageDetail} from '_src/api/api'

import './style.less'

const { TextArea } = Input

@Form.create({name: ''})
class PostMessage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
    }
  }

  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')
    // 带id进来是编辑
    if (id) {
      systemMessageDetail({id})
        .then(res => {
          this.setState({
            id,
            info: res.data,
            isLoading: false,
          })
          this.initEditor(res.data.content)
        })

    // 否则是新建
    } else {
      this.setState({isLoading: false})
      // 初始化富文本
      this.initEditor()
    }
  }

  // 初始化富文本
  initEditor (detail) {
    this.editor = new Editor('#editor')
    this.editor.customConfig.zIndex = 10
    this.editor.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'italic', // 斜体
      'list', // 列表
      'justify', // 对齐方式
      'image', // 插入图片
      'table', // 表格
      'undo', // 撤销
      'redo' // 重复
    ]
    this.editor.customConfig.customUploadImg = function (files, insert) {
      files.forEach(item => {
        var reader = new FileReader()
        reader.onload = function (e) {
          item.thumbUrl = reader.result
          UploadIMGToOss(item)
            .then(res => {
              insert(res)
            })
        }
        reader.readAsDataURL(item)
      })
    }
    this.editor.create(detail)
    this.editor.txt.html(detail)
  }

  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.content = `<div>${this.editor.txt.html()}</div>`
        debugger
        const {id} = this.state
        postSystemMessage(values, id)
          .then(res => {
            const _this = this
            message.success('编辑成功!', 1.2, () => {
              _this.props.history.replace('/app/message/detail?id=' + res.data.id)
            })
          })
      } else {
        document.querySelector('#main').scrollTop = 0
      }
    })
  }

  render () {
    const {
      info,
      isLoading,
    } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <Layout className="postMessage-page" style={{ padding: 20, paddingTop: 40, backgroundColor: 'white' }}>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='flex-h-a' title='发布系统消息' style={{borderLeft: '5px solid #1890ff', height: 30}} />
        <div style={{paddingTop: 40}}>
          <Form onSubmit={this.handleSubmit} style={{paddingLeft: 30}}>
            <Form.Item label="消息标题：" className='flex'>
              {getFieldDecorator('title', {
                rules: [{
                  required: true,
                  message: '请输入消息标题',
                }],
                initialValue: info && info.title ? info.title : '',
              })(
                <TextArea placeholder="消息标题" style={{width: 600, height: 100 }} />
              )}
            </Form.Item>
            <Form.Item label="消息详情：" className='flex'>
              <div id="editor" className='editor-inner'>
                <p>消息详情...</p>
              </div>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size='large' style={{width: 250, marginLeft: 90, marginTop: 40}}>保存</Button>
            </Form.Item>
          </Form>
        </div>
      </Layout>
    )
  }
}

export default PostMessage